import script from "./SubkontraktorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubkontraktorPage.vue?vue&type=script&setup=true&lang=js"

import "./SubkontraktorPage.vue?vue&type=style&index=0&id=36fc3e0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36fc3e0e"]])

export default __exports__